// eslint-disable-next-line no-restricted-imports
import { isFedRamp } from '@atlaskit/atlassian-context/is-fedramp';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { fg } from '@confluence/feature-gating';
import { expValEquals } from '@confluence/feature-experiments';

export const isContentTypeEnabledInCurrentEnv = (
	contentType: 'whiteboard' | 'database' | 'slide' | null | undefined,
): boolean => {
	if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
		if (fg('use_frontend_feature_encoding_sdk')) {
			const featureKeyMap = {
				database: 'confluence-databases',
				slide: 'confluence-slides',
				whiteboard: 'confluence-whiteboards',
			} as const;
			const isEnvEnabled = isFeatureEnabled('confluence', featureKeyMap[contentType], {
				'fedramp-moderate': () => fg('confluence_frontend_enable_canvas_types_in_fedramp'),
				'isolated-cloud-commercial': () => fg('confluence_frontend_enable_canvas_types_in_ic'),
			});

			if (contentType === 'slide') {
				return (
					isEnvEnabled &&
					!fg('cc-mui-slides-opted-out') &&
					expValEquals('cc-mui-slides-experiment', 'isEnabled', true)
				);
			}

			return isEnvEnabled;
		}

		if (contentType === 'slide') {
			return (
				!isFedRamp() &&
				!fg('cc-mui-slides-opted-out') &&
				expValEquals('cc-mui-slides-experiment', 'isEnabled', true)
			);
		}

		return !isFedRamp();
	}

	return true;
};
